import React from 'react';
import Header from './Header'
import Logout from './Logout';
const LoginPage = () => {
  return (
    <div className="app">
     
      <Header/>
      <Logout/>
    </div>
  );
};

export default LoginPage;
